module.exports = __webpack_public_path__ + "static/media/webweaver1.fd788363.jpeg";